import React, { useMemo } from 'react';
import { BsTrash } from 'react-icons/bs';
import { HStack, Icon, IconButton } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { CypressIds } from '../../../../../../../../constants/cypressIds';
import colors from '../../../../../../../../styles/theme/foundation/colors';
import RequirementTemplateBlueprintType from '../../../../../../../../types/RequirementTemplateBlueprintType';
import TemplateBlockQuestionsPopover from '../TemplateBlockQuestionsPopover';

const TemplateBlockFooter = ({
  blueprint = null,
  templateBlock = {},
  onDelete,
  borderColor = colors.greyScale['200'],
  dusk = undefined,
  cypressId = undefined,
  requirementTypeId = undefined,
  requirementType = undefined
}) => {
  const aiCypressId = useMemo(() => {
    if (requirementType === 'insurance_policy_type') {
      return CypressIds.recordQuestionPolicyIcon(requirementTypeId);
    }

    if (requirementType === 'document_type') {
      return CypressIds.recordQuestionDocIcon(requirementTypeId);
    }

    return null;
  }, []);

  return (
    <HStack
      borderTop={`1px solid ${borderColor}`}
      h="100%"
      justifyContent="flex-end"
      maxH="40px"
      mt={4}
      px={4}
      py={2}
      spacing={0}
    >
      {templateBlock?.requirementTemplateQuestions?.length > 0 && (
        <TemplateBlockQuestionsPopover
          blueprint={blueprint}
          cypressId={aiCypressId}
          requirementType={requirementType}
          requirementTypeId={requirementTypeId}
          templateBlock={templateBlock}
        />
      )}
      <IconButton
        aria-label="Delete Requirement Block"
        data-cy={cypressId}
        dusk={dusk}
        icon={<Icon as={BsTrash} h="18.25px" w="16.2`5px" />}
        variant="textGrey"
        onClick={evt => {
          evt.stopPropagation();
          evt.preventDefault();
          onDelete();
        }}
      />
    </HStack>

  );
};

TemplateBlockFooter.propTypes = {
  blueprint: RequirementTemplateBlueprintType,
  templateBlock: PropTypes.object,
  onDelete: PropTypes.func,
  borderColor: PropTypes.string,
  dusk: PropTypes.string,
  cypressId: PropTypes.string,
  requirementTypeId: PropTypes.number,
  requirementType: PropTypes.string
};

export default TemplateBlockFooter;
